var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 130C100.899 130 130 100.899 130 65C130 29.1015 100.899 0 65 0C29.1015 0 0 29.1015 0 65C0 100.899 29.1015 130 65 130Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 129.5C100.622 129.5 129.5 100.622 129.5 65C129.5 29.3776 100.622 0.5 65 0.5C29.3776 0.5 0.5 29.3776 0.5 65C0.5 100.622 29.3776 129.5 65 129.5Z",
    stroke: "#52B788"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 112C91.4051 112 112 101.479 112 88.5C112 75.5213 91.4051 65 66 65C40.5949 65 20 75.5213 20 88.5C20 101.479 40.5949 112 66 112Z",
    fill: "#52B788"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111.5C91.129 111.5 111.5 101.203 111.5 88.5C111.5 75.7975 91.129 65.5 66 65.5C40.871 65.5 20.5 75.7975 20.5 88.5C20.5 101.203 40.871 111.5 66 111.5Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4766 79C84.702 79 99.4766 64.2254 99.4766 46C99.4766 27.7746 84.702 13 66.4766 13C48.2512 13 33.4766 27.7746 33.4766 46C33.4766 64.2254 48.2512 79 66.4766 79Z",
    fill: "#52B788"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4766 78.5C84.4258 78.5 98.9766 63.9493 98.9766 46C98.9766 28.0507 84.4258 13.5 66.4766 13.5C48.5273 13.5 33.9766 28.0507 33.9766 46C33.9766 63.9493 48.5273 78.5 66.4766 78.5Z",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigProfile);
export default __webpack_public_path__ + "static/media/big-profile.26565b58c0a9f344f3ab2d9f800721f6.svg";
export { ForwardRef as ReactComponent };